export default [
  {
    path: 'consultorias/prorroga-entregable/:consultoriaId/:entregableId',
    name: 'consultoria-prorrogaEntregable',
    component: () => import('../prorroga-entregable/index.vue'),
  },
];
